import { useForm } from "react-hook-form";
import { useRef, useState } from "react";
import { zodResolver } from "@hookform/resolvers/zod";
import { loginSchema } from "./schema/login-schema";
import { useMutation } from "@tanstack/react-query";
import { toast } from "sonner";
import { z } from "zod";
import SupabasePool from "../../lib/supabaseClient";
import PasswordInputField from "../../components/shared/inputPasswordField";
import InputField from "../../components/shared/inputField";
import { Button } from "@/components/ui/button";
import { Form } from "@/components/ui/form";
import { CardDescription, CardTitle } from "@/components/ui/card";
import useStore from "@/store/zustandStore";
import { getAdminByEmail } from "@/services/getAdminByEmail";

export interface LoginSchemaProps {
  message?: string;
  token: string;
  Auth: boolean;
}

export default function LoginForm() {
  const ref = useRef<boolean>(false);
  const [lock, setLock] = useState(false);
  const { setAuth } = useStore();
  const pool = SupabasePool.getInstance();

  const { mutate } = useMutation({
    mutationFn: async (data: z.infer<typeof loginSchema>) => {
      // password 검증
      const { data: loginData } = await pool.auth.signInWithPassword({
        email: data.user_id,
        password: data.user_password,
      });

      // password Session확인
      if (loginData?.session) {
        const adminMail = loginData.session.user.email;

        const res = await getAdminByEmail({ pool, email: adminMail! });

        if (res.error || !res.data?.id) {
          throw new Error(
            `정보가 일치하지 않거나 존재하지 않는 사용자 입니다.`
          );
        }

        return { userData: res.data };
      }

      throw new Error("정보가 일치하지 않거나 존재하지 않는 사용자 입니다.");
    },
    onSuccess: ({ userData }) => {
      toast.success("로그인 되었습니다.");
      setAuth(userData);
    },
  });

  const form = useForm({
    defaultValues: {
      user_id: "",
      user_password: "",
    },
    resolver: zodResolver(loginSchema),
  });

  const onSubmitHandler = async (loginData: z.infer<typeof loginSchema>) => {
    if (ref.current) return;
    setLock(true);
    ref.current = true;
    console.log(loginData);
    mutate(loginData);

    setTimeout(() => {
      ref.current = false;
      setLock(false);
    }, 2000);
  };

  return (
    <section className="max-w-[600px] mx-auto">
      <div className="mb-4 flex flex-col gap-2  py-5 ]">
        <CardTitle className="text-3xl text-center">PORTFOLIO</CardTitle>
        <CardDescription className="text-center">Admin</CardDescription>
        <div className="border-y py-4 border-border mt-4 ">
          <div className="text-xs text-indigo-200 gap-2 text-center! ">
            해당 PORTFOLIO는 권한이 인가 된 사용자만 사용가능합니다.
          </div>
        </div>
      </div>
      <Form {...form}>
        <form
          onSubmit={form.handleSubmit(onSubmitHandler)}
          className="flex flex-col gap-4"
        >
          {/* <LoginHeader /> */}
          <InputField
            name="user_id"
            placeholder="Admin Id"
            label="User"
            className="py-3 px-3!  border-0 border-b  focus-visible:ring-0 transition-all"
          />

          <PasswordInputField
            name="user_password"
            placeholder="password"
            className="py-3  px-3!  border-0 border-b   focus-visible:ring-0 transition-all"
          />

          <Button disabled={lock} className="w-full  p-6">
            Login
          </Button>
        </form>
      </Form>
    </section>
  );
}
